// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_environment_codec from "./web_environment_codec.js";
import * as Mapre_web__Web_environment_model from "./web_environment_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return Stdlib.invalid_arg("environment_without_project");
  }
  switch (match.TAG) {
    case /* Project */ 2 :
    case /* Session */ 3 :
      break;
    default:
      return Stdlib.invalid_arg("environment_without_project");
  }
  return "/api/workspaces/" + (match._0 + ("/projects/" + (match._1 + "/environment")));
}

function failed(t, message) {
  if (/* tag */ typeof message !== "object" && typeof message !== "function") {
    Curry._1(t.emit, {
      TAG: /* Environment */ 33,
      _0: {
        TAG: /* Failed */ 7,
        _0: "Unable to access this environment."
      }
    });
    return Curry._1(t.failure, message);
  }
  if (message.TAG === /* Failed */ 1) {
    const message$1 = message._0;
    if (message$1 === "project_version_conflict") {
      return Curry._1(t.emit, {
        TAG: /* Environment */ 33,
        _0: /* Conflict */ 4
      });
    } else {
      return Curry._1(t.emit, {
        TAG: /* Environment */ 33,
        _0: {
          TAG: /* Failed */ 7,
          _0: message$1
        }
      });
    }
  }
  Curry._1(t.emit, {
    TAG: /* Environment */ 33,
    _0: {
      TAG: /* Failed */ 7,
      _0: "Unable to access this environment."
    }
  });
  Curry._1(t.failure, message);
}

function request(t, body, suffix, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path(t) + suffix).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).environment_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            failed(t, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        failed(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function history(t, form, more) {
  Curry._1(t.emit, {
    TAG: /* Environment */ 33,
    _0: /* History_loading */ 7
  });
  const suffix = more ? Stdlib__Option.fold("", (function (v) {
      return "?before=" + String(v);
    }), form.next_version) : "";
  request(t, undefined, "/versions" + suffix, (function (json) {
    const match = Mapre_web__Web_environment_codec.history(json);
    Curry._1(t.emit, {
      TAG: /* Environment */ 33,
      _0: {
        TAG: /* History_loaded */ 8,
        _0: match[0],
        _1: match[1],
        _2: more
      }
    });
  }));
}

function load(t) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Environment */ 33,
    _0: /* Reload */ 1
  });
  request(t, undefined, "", (function (json) {
    const action_0 = Mapre_web__Web_environment_codec.receipt(json);
    const action_1 = crypto.randomUUID();
    const action = {
      TAG: /* Loaded */ 1,
      _0: action_0,
      _1: action_1
    };
    Curry._1(t.emit, {
      TAG: /* Environment */ 33,
      _0: action
    });
    Stdlib__Option.iter((function (form) {
      if (form.history_open) {
        return history(t, form, false);
      }
      
    }), Curry._1(t.model, undefined).environment_form);
  }));
}

function edit(t, draft) {
  const action_1 = crypto.randomUUID();
  const action = {
    TAG: /* Edited */ 4,
    _0: draft,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Environment */ 33,
    _0: action
  });
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Close */ 0) {
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Environment */ 33,
        _0: /* Close */ 0
      });
    }
    
  } else if (action.TAG === /* Open */ 0 && Mapre_web__Web_model.can_edit_environment(Curry._1(t.model, undefined))) {
    cancel(t);
    const action$1 = {
      TAG: /* Open */ 0,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Environment */ 33,
      _0: action$1
    });
    return load(t);
  }
  if (!Mapre_web__Web_model.can_edit_environment(Curry._1(t.model, undefined))) {
    return;
  }
  const form = Curry._1(t.model, undefined).environment_form;
  if (form !== undefined) {
    if (!form.pending && !form.loading) {
      if (/* tag */ typeof action !== "object" && typeof action !== "function") {
        switch (action) {
          case /* Reload */ 1 :
            return load(t);
          case /* Save */ 2 :
            const configuration = Mapre_web__Web_environment_model.configuration(form.draft);
            if (configuration !== undefined && Mapre_web__Web_environment_model.can_save(form)) {
              cancel(t);
              Curry._1(t.emit, {
                TAG: /* Environment */ 33,
                _0: /* Pending */ 3
              });
              return request(t, Mapre_web__Web_environment_codec.body(form, configuration), "", (function (json) {
                const action_0 = Mapre_web__Web_environment_codec.receipt(json);
                const action_1 = crypto.randomUUID();
                const action = {
                  TAG: /* Saved */ 6,
                  _0: action_0,
                  _1: action_1
                };
                Curry._1(t.emit, {
                  TAG: /* Environment */ 33,
                  _0: action
                });
                Stdlib__Option.iter((function (form) {
                  if (form.history_open) {
                    return history(t, form, false);
                  }
                  
                }), Curry._1(t.model, undefined).environment_form);
              }));
            } else {
              return;
            }
          case /* History */ 5 :
            if (!form.history_loading) {
              return history(t, form, false);
            } else {
              return;
            }
          case /* More_history */ 6 :
            if (!form.history_loading && form.next_version !== undefined) {
              return history(t, form, true);
            } else {
              return;
            }
          default:
            return;
        }
      } else {
        switch (action.TAG) {
          case /* Choose */ 2 :
            const init = form.draft;
            return edit(t, {
              source: action._0,
              path: init.path,
              filename: init.filename,
              content: init.content,
              context: init.context,
              target: init.target,
              arguments: init.arguments
            });
          case /* Change */ 3 :
            return edit(t, Mapre_web__Web_environment_model.change(form.draft, action._0, action._1));
          case /* Upload */ 5 :
            const init$1 = form.draft;
            return edit(t, {
              source: init$1.source,
              path: init$1.path,
              filename: action._0,
              content: action._1,
              context: init$1.context,
              target: init$1.target,
              arguments: init$1.arguments
            });
          case /* Failed */ 7 :
            return Curry._1(t.emit, {
              TAG: /* Environment */ 33,
              _0: {
                TAG: /* Failed */ 7,
                _0: action._0
              }
            });
          case /* Use_revision */ 9 :
            return edit(t, Mapre_web__Web_environment_model.draft(action._0.configuration));
          default:
            return;
        }
      }
    } else if (Caml_obj.caml_equal(action, /* Reload */ 1)) {
      return load(t);
    } else {
      return;
    }
  }
  
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
